import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input() totalTab: number;
  @Input() nowPage: number = 1;
  @Input() maxSize: number = 3;
  @Input() itemsPerPage: number = 10;
  @Output() page = new EventEmitter<number>();

  currentPage: number;
  constructor() { }

  ngOnInit() {

  }

  ngOnChanges() {
    if (this.totalTab === 0) {
      this.currentPage = 0;
    } else {
      this.currentPage = this.nowPage;
    }
    // console.log('Total tab', this.totalTab);
  }

  pageChanged(event) {
    // console.log('PAGE', event.page);
    const selectPage = event.page;
    this.page.emit(selectPage);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination/pagination.component.ts